import React from "react";
import Home from "../../pages/Home/Home";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import "./Layout.css";
import Menus from "../Menus/Menus";
import { useSidebar } from "../../hooks/useSidebar";

const Layout = () => {
  const { isExpanded, toggleSidebar } = useSidebar();

  //change toggle
  const handleToggle = () => {
    toggleSidebar();
  };
  
  return (
    <div className="sidebar-section">
      <div className={isExpanded ? "sidebar-toggle sidebar" : "sidebar"}>
        <div className="sidebar-toggle-icons">
          <p onClick={handleToggle}>
            {isExpanded ? (
              <AiOutlineDoubleLeft size={30} />
            ) : (
              <AiOutlineDoubleRight size={30} />
            )}
          </p>
        </div>
        <Menus toggle={isExpanded} />
      </div>
      <div className={`main-content ${isExpanded ? 'sidebar-expanded' : 'sidebar-collapsed'}`}>
        <Home />
      </div>
    </div>
  );
};

export default Layout;
